/**
 * The four roles, least to most able. A role can do everything the roles
 * before it can. Shared between server (route gating) and client (which
 * controls to show), so the two cannot drift.
 */
export const ROLES = ['read_only', 'nurse', 'clinician', 'admin'] as const
export type Role = (typeof ROLES)[number]

export const ROLE_LABELS: Record<Role, string> = {
  read_only: 'Read only',
  nurse: 'Nurse',
  clinician: 'Clinician',
  admin: 'Admin',
}

/** What each role adds over the one before it — the words on the Users screen. */
export const ROLE_DESCRIPTIONS: Record<Role, string> = {
  read_only: 'Sees patients, results and reports; changes nothing.',
  nurse: 'Also starts assessments, enters observations and uploads results.',
  clinician: 'Also writes comments, signs off reports and sends them to Semble.',
  admin: 'Also edits reference ranges and report copy, and manages users.',
}

export function isRole(value: unknown): value is Role {
  return typeof value === 'string' && (ROLES as readonly string[]).includes(value)
}

/** True when `role` is `min` or anything above it. */
export function atLeast(role: Role | null | undefined, min: Role): boolean {
  if (role === null || role === undefined) return false
  return ROLES.indexOf(role) >= ROLES.indexOf(min)
}
